import { useQuery, useQueryClient } from '@tanstack/react-query'

import { useAuth, useTRPC } from '@langmail/shared-ui'

export const useProfile = () => {
  const { user } = useAuth()
  const trpc = useTRPC()
  const queryClient = useQueryClient()

  const query = useQuery(trpc.user.getProfile.queryOptions(undefined, { enabled: !!user }))

  type ProfileData = NonNullable<typeof query.data>

  const updateProfile = (updates: Partial<ProfileData>) => {
    queryClient.setQueryData(trpc.user.getProfile.queryKey(), (old) => (old ? { ...old, ...updates } : old))
  }

  return {
    profile: query.data ?? null,
    loading: query.isLoading,
    updateProfile,
    refetchProfile: query.refetch,
  }
}
